import axiosInstance from "../axiosInstance";

const BASE_URL = "/elearning/dashboard";

/**
 * @param {{ branch_id?: string, year?: number }} params — branch_id "all" hoặc bỏ = tất cả chi nhánh
 */
export const getElearningDashboard = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};
